import React, { useState } from "react";
import { FaBuilding, FaCheckCircle, FaPlus } from "react-icons/fa";
import CreateFirmDrawer from "../CreateFirmDrawer";
import usePermission from "../../../Hooks/usePermission";
import { PageHeader } from "../../shared";

function FirmsHeader({
  isLoading,
  totalFirms,
  activeCount = 0,
  firms,
  setFirms,
  onFirmCreated,
}) {
  const [showCreateDrawer, setShowCreateDrawer] = useState(false);
  const { hasPermission } = usePermission();

  const stats = [
    { icon: FaBuilding, value: totalFirms, label: "Firma", color: "blue" },
    { icon: FaCheckCircle, value: activeCount, label: "Aktif", color: "emerald" },
  ];

  const actions = [
    ...(hasPermission("firms.create")
      ? [
          {
            icon: FaPlus,
            label: "Yeni Firma",
            onClick: () => setShowCreateDrawer(true),
            variant: "primary",
          },
        ]
      : []),
  ];

  return (
    <div className="shrink-0">
      <div className="px-3 py-2.5 sm:p-4 md:p-6 bg-gray-50/80 sm:bg-gray-50">
        <PageHeader
          icon={FaBuilding}
          iconColor="blue"
          title="Firma Yönetimi"
          subtitle="Firma bilgilerini yönetin ve takip edin"
          stats={stats}
          actions={actions}
          isLoading={isLoading}
          mobileSlotId="firms-toolbar-mobile-slot"
        />
      </div>

      <CreateFirmDrawer
        firms={firms}
        open={showCreateDrawer}
        onClose={() => setShowCreateDrawer(false)}
        onFirmCreated={() => {
          onFirmCreated();
        }}
      />
    </div>
  );
}

export default FirmsHeader;
